import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { JhiLanguageService } from '../../shared/core-utils';
import { ProgramService } from '../../shared/program/service/program.service';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { Program } from '../../shared/program/model/program';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NavbarMessageEvent } from '../../shared/model/navbar-message.event';
import { AlertService } from '../../shared/alert/alert.service';
import { DateHelperService } from '../../shared/service/date.helper.service';
import { Principal } from '../../shared';
import { ADD_NEW_PROGRAM, ViewEnum } from '../../app.constants';
import { HelpService } from '../../shared/service/help.service';
import { ADD_PROGRAM_PERMISSION } from '../../shared/auth/permissions';

@Component({
    selector: 'jhi-create-program',
    templateUrl: 'create-program-dialog.component.html',
    styleUrls: ['create-program-dialog.component.css']
})
export class CreateProgramDialogComponent implements OnInit, OnDestroy {

    ADD_PROGRAM_PERMISSION = ADD_PROGRAM_PERMISSION;
    helpLink: string;
    crops: string[];
    cropName: string;
    cropChanged = new Subject<string>();
    program: Program = new Program();
    startDate: NgbDate;
    isLoading: boolean;
    breedingLocationDefaultId: number;
    storageLocationDefaultId: number;
    user?: any;

    constructor(private alertService: AlertService,
                private activeModal: NgbActiveModal,
                private programService: ProgramService,
                public dateHelperService: DateHelperService,
                private languageService: JhiLanguageService,
                private helpService: HelpService,
                private principal: Principal
    ) {
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(ADD_NEW_PROGRAM).toPromise().then((response) => {
                if (response.body) {
                    this.helpLink = response.body;
                }
            }).catch((error) => {
            });
        }
    }

    ngOnDestroy(): void {
    }

    async ngOnInit() {
        const identity = await this.principal.identity();
        this.user = identity;
        if (this.canViewAllCrops()) {
            this.crops = this.user.crops.map((crop) => crop.cropName);
        } else {
            this.crops = this.user.userRoles
                .filter((userRole) => userRole.crop !== null && userRole.crop !== undefined)
                .map((userRole) => userRole.crop.cropName);
        }
    }

    onCropChange() {
    }

    canViewAllCrops() {
        const userRoles = this.user.userRoles;
        return userRoles && userRoles.some((userRole) => userRole.role.name === 'SuperAdmin' || userRole.role.roleType.id === 1);
    }

    isFormValid(f) {
        const form = f.form;
        if (!Object.values(form.controls).filter((control: any) => !control.disabled).length) {
            return false;
        }

        return f.form.valid && this.cropName && this.breedingLocationDefaultId != null && this.storageLocationDefaultId != null;
    }

    async create(f) {
        if (this.isFormValid(f)) {
            this.isLoading = true;

            const identity = await this.principal.identity(true, this.cropName);
            this.user = identity;

            const hasAuthoritiesForCrop = this.ADD_PROGRAM_PERMISSION.some((permission) => this.user.authorities.includes(permission));
            if (hasAuthoritiesForCrop) {
                const programBasicDetails = {};
                programBasicDetails['name'] = this.program.name;
                this.program.startDate = this.dateHelperService.convertFormattedNgbDateToString(this.startDate, '-');
                programBasicDetails['startDate'] = this.program.startDate;
                programBasicDetails['breedingLocationDefaultId'] = this.breedingLocationDefaultId;
                programBasicDetails['storageLocationDefaultId'] = this.storageLocationDefaultId;
                this.programService.addProgram(programBasicDetails, this.cropName).subscribe((program) => {
                    const message: NavbarMessageEvent = {
                        programSelected: program,
                        toolSelectedUrl: ViewEnum.PROGRAM_SETTING_MANAGER,
                        toolSelectedName: 'Manage Program Settings'
                    };
                    window.parent.postMessage(message, '*');
                    this.alertService.success('program.create.success');
                    this.clear();
                }, () => {
                    this.isLoading = false;
                    this.activeModal.dismiss('cancel');
                }
                );
            } else {
                this.alertService.error('program.create.permissions.error');
                this.isLoading = false;
            }
        }
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

}

@Component({
    selector: 'jhi-create-program-popup',
    template: ''
})
export class CreateProgramPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private popupService: PopupService
    ) {

    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(() => {
            this.popupService.open(CreateProgramDialogComponent as Component, { modalDialogClass: 'modal-md', backdrop: 'static' });
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

}
